import script from "./MenuUser.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuUser.vue?vue&type=script&setup=true&lang=js"

import "./MenuUser.vue?vue&type=style&index=0&id=b4d8263c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4d8263c"]])

export default __exports__